import instance from './http.service';

const NftServices = {
  createUris: async (data, chain) => {
    return await instance.post(`nft/create-uris`, {
      nfts: data,
      chain,
    });
  },
  /** Owned CryptoverseAI token ids via backend Alchemy index. */
  getOwned: async (chain, owner) => {
    return await instance.get(`nft/owned`, {
      params: { chain, owner },
    });
  },
};

export default NftServices;
